import React from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';

const BitcoinCalc = () => {
  const { price, error, isConnecting } = useWebSocket();
  const USD_AMOUNT = 43884;

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 8
    }).format(num);
  };

  return (
    <div className="bitcoin-calc">
      {error ? (
        <div className="error">{error}</div>
      ) : (
        <div className="calculation">
          {isConnecting ? (
            <span className="loading">Loading...</span>
          ) : price ? (
            <>
              <span className="amount">${USD_AMOUNT} = </span>
              <span className="btc">{formatNumber(USD_AMOUNT / price)} BTC</span>
            </>
          ) : (
            <span className="loading">Waiting for price...</span>
          )}
        </div>
      )}
    </div>
  );
};

export default BitcoinCalc; 